import React from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { Guide } from '../../interfaces';
import { SearchField } from '../../components/SearchField';
import CustomerTable, { CustomerTableHandle } from './CustomerTable';
import { DataGridPro, GridColDef, GridPaginationModel } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid/locales';
interface Props {
  guides: Guide[];
  totalCount: number;
  loading: boolean;
  searchTerm: string;
  onSearchTermChange(searchTerm: string): void;
  paginationModel: GridPaginationModel;
  onPaginationModelChange(paginationModel: GridPaginationModel): void;
  showInternalBackButton?: boolean;
  hideSearchBar?: boolean;
  onGuideListVisibilityChange?(isVisible: boolean): void;
}
interface State {
  isGuideTableVisible: boolean;
  guideId: any;
  title: string;
}
export default class GuideTable extends React.PureComponent<Props, State> {
  private customerTableRef = React.createRef<CustomerTableHandle>();

  constructor(props) {
    super(props);
    this.state = {
      isGuideTableVisible: true,
      guideId: 0,
      title: '',
    };
  }
  handleDocumentClick = (id, title) => {
    this.setState({ isGuideTableVisible: false, guideId: id, title: title });
    this.props.onGuideListVisibilityChange?.(false);
  };
  handleBack = () => {
    this.setState({ isGuideTableVisible: true });
    this.props.onGuideListVisibilityChange?.(true);
  };
  handleBackNavigation = () => {
    if (this.state.isGuideTableVisible) {
      return false;
    }
    if (this.customerTableRef.current?.handleBackNavigation()) {
      return true;
    }
    this.handleBack();
    return true;
  };
  renderTable = () => {
    const rows = this.props.guides.map((x) => ({
      id: x.docId,
      docName: x.docName,
      title: x.title,
      docId: x.docId,
    }));

    const columns: GridColDef<(typeof rows)[number]>[] = [
      {
        field: 'docName',
        headerName: 'Nummer',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => (
          <Button
            size="small"
            onClick={() => this.handleDocumentClick(params.row.docId, params.row.title)}
            sx={{ minWidth: 0, px: 0, textDecoration: 'underline', fontWeight: 600 }}>
            {params.row.docName}
          </Button>
        ),
      },
      {
        field: 'title',
        headerName: 'Anvisning tittel',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
      },
    ];

    return (
      <>
        <Paper elevation={1} sx={{ p: 2 }}>
          <DataGridPro
            autoHeight
            density="compact"
            rows={rows}
            columns={columns}
            localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
            pagination
            paginationMode="server"
            paginationModel={this.props.paginationModel}
            rowCount={this.props.totalCount}
            loading={this.props.loading}
            onPaginationModelChange={this.props.onPaginationModelChange}
            pageSizeOptions={[25, 50, 100]}
            sx={{
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 700,
              },
            }}
          />
        </Paper>
      </>
    );
  };
  renderSearchBar = () => {
    return (
      <>
        <Paper elevation={1}>
          <div>
            <SearchField filter={this.props.onSearchTermChange} parentSearchTerm={this.props.searchTerm} />
          </div>
          <div style={{ textAlign: 'right' }}>
            <Typography variant="caption">Antall: {this.props.totalCount.toLocaleString('nb-NO')}</Typography>
          </div>
        </Paper>
      </>
    );
  };
  render() {
    let { isGuideTableVisible } = this.state;
    if (isGuideTableVisible) {
      return (
        <>
          {!this.props.hideSearchBar && this.renderSearchBar()}
          {this.renderTable()}
        </>
      );
    } else {
      return (
        <CustomerTable
          ref={this.customerTableRef}
          selectedGuide={this.state.title}
          handleBack={this.handleBack}
          guideId={this.state.guideId}
          showInternalBackButton={this.props.showInternalBackButton ?? true}
        />
      );
    }
  }
}
